import React from 'react';
import { motion } from 'framer-motion';
interface TestimonialProps {
  name: string;
  role: string;
  company: string;
  quote: string;
  index: number;
}
function TestimonialCard({
  name,
  role,
  company,
  quote,
  index
}: TestimonialProps) {
  return <motion.div className="glass rounded-xl p-8 md:p-10 border-l-2 border-l-ultra-purple/40 relative overflow-hidden" initial={{
    opacity: 0,
    y: 40
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.3
  }} transition={{
    delay: index * 0.2,
    duration: 0.7,
    ease: [0.22, 1, 0.36, 1]
  }} data-id="element-102">
      {/* Decorative quote mark */}
      <span className="absolute top-4 right-6 font-heading text-8xl md:text-9xl text-ultra-purple/10 leading-none select-none pointer-events-none" aria-hidden="true" data-id="element-103">
        &ldquo;
      </span>

      <div className="relative z-10" data-id="element-104">
        <p className="font-body text-base md:text-lg text-white/80 italic leading-relaxed mb-8" data-id="element-105">
          &ldquo;{quote}&rdquo;
        </p>

        <div data-id="element-106">
          <p className="font-heading text-base md:text-lg text-ultra-gold" data-id="element-107">
            {name}
          </p>
          <p className="font-body text-sm text-white/50" data-id="element-108">
            {role}, {company}
          </p>
        </div>
      </div>
    </motion.div>;
}
export function TrustedBySection() {
  return <section className="relative min-h-screen w-full flex items-center" data-id="element-109">
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse 50% 40% at 50% 50%, rgba(139,92,246,0.05) 0%, transparent 60%)'
    }} aria-hidden="true" data-id="element-110" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 md:px-12 py-20" data-id="element-111">
        <motion.p className="font-heading text-xs md:text-sm uppercase tracking-[0.3em] text-ultra-gold mb-16 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.5
      }} transition={{
        duration: 0.6
      }} data-id="element-112">
          Trusted by Visionaries
        </motion.p>

        <div className="space-y-6 md:space-y-8" data-id="element-113">
          <TestimonialCard name="Nikoleta Xenophontos" role="CRO" company="Aurelia Gaming" quote="Ultragamer didn't just improve our metrics — it fundamentally changed how we understand our players. The predictive accuracy is unlike anything we've deployed." index={0} data-id="element-114" />
          <TestimonialCard name="Theron Makrides" role="CEO" company="Helix Interactive" quote="We saw a 340% increase in high-value player engagement within the first quarter. The ROI conversation was over before it started." index={1} data-id="element-115" />
          <TestimonialCard name="Calista Iordanou" role="VP Product" company="Kronos Bet" quote="The personalization engine feels like it reads minds. Our players stay longer, play more, and genuinely enjoy the experience." index={2} data-id="element-116" />
        </div>
      </div>
    </section>;
}